// EE TODO BMS: uncomment the following line when first use this function and remove this comment
import { lazy } from "react";

/**
 * Custom fields registry
 * add to this object the custom fields you want to use in the application form editor
 * to do so add line like this: FieldWithSubfields: lazy(() => import("./customFields/fieldWithSubfields"))
 *                               ^ the key is the name of the custom field. ^ the value is a lazy loaded import of the custom field
 */
const customFieldsRegistry = Object.freeze({
  CustomRegeneronDiagnosisSelector: lazy(() => import("./customFields/CustomRegeneronDiagnosisSelector")),
  NumberInputWithUnits: lazy(() => import("./customFields/NumberInputWithUnits")),
  SectionLabel: lazy(() => import("./customFields/SectionLabel")),
  CheckboxWithContentField: lazy(() => import("./customFields/CheckboxWithContentField")),
  // Genentech free-drug sections that aren't declarative yet, each as its OWN named field type (never a
  // generic section switch). prescription legitimately stays whole (its options/values/disabled derive
  // at runtime from expressEnrollmentConfiguration); consent/insurance/medical are interim and get
  // replaced with declarative JSON as the engine gaps (derivedValue, fieldMultiplier bare variant) land.
  // Same lazy() contract as the entries above.
  genentechFreeDrugPrescription: lazy(() =>
    import("../Patient/ApplicationFormEditor/Genentech/freeDrug/form/formSections/Prescription")
  ),
  genentechFreeDrugConsent: lazy(() =>
    import("../Patient/ApplicationFormEditor/Genentech/freeDrug/form/formSections/PatientConsent")
  ),
  genentechFreeDrugInsurance: lazy(() =>
    import("../Patient/ApplicationFormEditor/Genentech/freeDrug/form/formSections/Insurance")
  ),
  genentechFreeDrugMedical: lazy(() =>
    import("../Patient/ApplicationFormEditor/Genentech/freeDrug/form/formSections/Medical")
  )
});

export default customFieldsRegistry;
